//Packages
import React from "react";
import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import { BarChartOutlined, SyncOutlined } from "@ant-design/icons";
import * as echarts from "echarts";
import moment from "moment";
import { IonSpinner, IonCardSubtitle } from "@ionic/react";
//Styles
import "./RoutineProgress.scss";
//Type Definitions
import { IActivity } from "../interfaces";

interface IProps {
  activityStore?: any;
  activity?: IActivity;
}

@inject("activityStore")
@observer
class RoutineProgress extends React.Component<IProps> {
  @observable public loading = false;
  @observable public error = null;
  @observable public chartData: object[] = [];
  @observable public pageOneData: object[] = [];

  private chartRef = React.createRef<HTMLDivElement>();
  private chartInstance: echarts.ECharts | null = null;

  mapRoutineInstances = () => {
    const chartDates = Object.keys(
      this.props.activityStore.activeRoutine.history
    );
    const historyLog = this.props.activityStore.activeRoutine.history;
    chartDates.map((date) => {
      const currentLog = {
        name: moment(date).format("MM/DD/YYYY"),
        Target: historyLog[date].frequency,
        Completed: historyLog[date].timesCompleted,
      };
      this.chartData.push(currentLog);
      return this.chartData;
    });
  };

  sortData(chartData: any) {
    return chartData.sort(this.sortObjs);
  }

  sortObjs(a: IActivity, b: IActivity) {
    const timeA = new Date(a.name).getTime();
    const timeB = new Date(b.name).getTime();
    return timeA - timeB;
  }

  mapPageOne = () => {
    const sortedData = this.sortData(this.chartData);
    const pageOne = sortedData.slice(-4);
    return pageOne;
  };

  componentDidMount() {
    if (!!this.props.activityStore.activeRoutine.history === true) {
      this.initChart();
    }
  }

  componentDidUpdate() {
    if (!!this.props.activityStore.activeRoutine.history === true && this.chartRef.current) {
      this.initChart();
    }
  }

  componentWillUnmount() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }

  initChart = () => {
    if (!this.chartRef.current) return;

    // Dispose existing chart instance
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }

    this.mapRoutineInstances();
    const mapResults = this.mapPageOne();

    // Initialize ECharts instance
    this.chartInstance = echarts.init(this.chartRef.current);

    // const dummyData = [
    //   { date: "2025-06-10", target: 1, Completed: 1 },
    //   { date: "2025-06-12", target: 2, Completed: 3 },
    //   { date: "2025-06-12", target: 7, Completed: 2 },
    // ];

    // const dates: any = dummyData.map((item: { date: any; }) => item.date);
    // const targetData = dummyData.map((item: { target: any; }) => item.target);
    // const completedData = dummyData.map((item: { Completed: any; }) => item.Completed);
    // Extract data for chart
    const dates: any = mapResults.map((item: { name: any; }) => item.name);
    const targetData = mapResults.map((item: { Target: any; }) => item.Target);
    const completedData = mapResults.map((item: { Completed: any; }) => item.Completed);

    console.log("Routine Progress Data", {
      dates,
      targetData,
      completedData,
    });

    const option = {
      title: {
        show: false
      },
      tooltip: {
        // trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        }
      },
      legend: {
        data: ['Completed', 'Target'],
        bottom: 0,
        left: 'center'
      },
      xAxis: [
        {
          type: 'category',
          data: dates,
          axisPointer: {
            // type: 'shadow'
          },
          name: 'Week Ending On',
          nameLocation: 'middle',
          nameGap: 30
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Times Per Week',
          nameRotate: 90,
          nameLocation: 'middle',
          nameGap: 50
        }
      ],
      grid: {
        top: 20,
        right: 20,
        bottom: 80,
        left: 80
      },
      series: [
        {
          name: 'Completed',
          type: 'bar', //Change to 'line/bar' option 1
          // type: 'bar', //Change to 'bar/line' option 2
          data: completedData,
          itemStyle: {
            color: '#c084fc'
          },
          // areaStyle: {}, // option 3
          // smooth: true, // option 4
          barWidth: 20
        },
        {
          name: 'Target',
          type: 'line',  //Change to 'bar/line' option 1
          // type: 'line', //Change to 'line/bar' option 2
          data: targetData,
          itemStyle: {
            color: '#2563eb'
          },
          // areaStyle: {}, // option 3
          // smooth: true // option 4
        }
      ]
    };

    this.chartInstance.setOption(option);

    // Handle window resize
    window.addEventListener('resize', this.handleResize);
  };

  handleResize = () => {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  };

  render() {
    if (!!this.props.activityStore.activeRoutine.history === false) {
      return (
        <div className="center-text">
          <br />
          <h1 className="mont XL">Routine Progress</h1>
          {this.loading ? (
            <IonSpinner />
          ) : (
            !!this.props.activityStore.activeRoutine.history
          )}
          <IonCardSubtitle className="mont M">
            <SyncOutlined /> {this.props.activityStore.activeRoutine.name}
          </IonCardSubtitle>
          <BarChartOutlined className="bar-chart-icon" />
          <p className="open-sans">
            Not enough data available to display in a chart
          </p>
        </div>
      );
    } else if (!!this.props.activityStore.activeRoutine.history === true) {
      return (
        <div className="center-text">
          <br />
          <h1 className="mont XL">Routine Progress</h1>
          {this.loading ? (
            <IonSpinner />
          ) : (
            !!this.props.activityStore.activeRoutine.history
          )}
          <IonCardSubtitle className="mont M">
            <SyncOutlined /> {this.props.activityStore.activeRoutine.name}
          </IonCardSubtitle>
          {this.loading ? <IonSpinner /> : <div className="open-sans">
            <div
              ref={this.chartRef}
              style={{ width: '500px', height: '380px', margin: '0 auto' }}
            />
          </div>}

        </div>
      );
    }
  }
}

export default RoutineProgress;